import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getIdentityUrls, UserEndpoints } from './identity.config';
import { GetUserResponse } from './interface/identity.response';
import { UpdateUserRequest } from './interface/identity.request';
import { tap } from 'rxjs/operators';
import { APP_CONFIG } from '../../../tokens/app-config.token';
import { Environment } from '../../../../environments/environment.interface';

@Injectable({
  providedIn: 'root',
})
export class IdentityService {
  private readonly identityUrls: ReturnType<typeof getIdentityUrls>;

  constructor(
    private readonly httpClient: HttpClient,
    @Inject(APP_CONFIG) private readonly appConfig: Environment,
  ) {
    this.identityUrls = getIdentityUrls(this.appConfig);
  }

  updateProfile(profile: UpdateUserRequest): Observable<GetUserResponse> {
    return this.httpClient.patch<GetUserResponse>(this.identityUrls.IDENTITY_USER_ROUTE, profile);
  }

  // todo - validate the body parameters once api is ready
  updatePassword(oldPassword: string, newPassword: string): Observable<any> {
    return this.httpClient.patch<any>(`${this.identityUrls.IDENTITY_USER_ROUTE}/${UserEndpoints.CHANGE_PASSWORD_ENDPOINT}`, { oldPassword, newPassword });
  }

  getProfile(): Observable<GetUserResponse> {
    return this.httpClient.get<GetUserResponse>(this.identityUrls.IDENTITY_USER_ROUTE);
  }
}
